import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';

import { AuthProvider } from '../api/Auth';

// 导入页面组件
import VideoOverlay from '../pages/VideoOverlay';
import Promotion from '../pages/Promotion'
import HomePage from '../pages/HomePage';
import Dashboard from '../pages/admin/Dashboard';
import Appearance from '../pages/admin/Appearance';
import LinksManager from '../pages/admin/LinksManager';
import Login from '../pages/auth/Login';
import Register from '../pages/auth/Register';
import DymanicOverlay from '../pages/DymanicOverlay';

const AppRouter: React.FC = () => {
  // 这里可以从状态管理或上下文中获取认证状态

  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/:username/:linkPath?" element={<DymanicOverlay />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/logout" element={<Login />} />

          <Route path="/promotion_vip" element={<Promotion />} />
          <Route path="/promotion" element={<VideoOverlay />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/appearance"
            element={
              <ProtectedRoute>
                <Appearance />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/links"
            element={
              <ProtectedRoute>
                <LinksManager />
              </ProtectedRoute>
            }
          />
          {/* 添加更多路由 */}

          {/* 404 页面 - 重定向到首页 */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default AppRouter; 